module.exports = __webpack_public_path__ + "img/behaviour3.b3399aa.jpg";